
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document-toolkit",
      function () {
        return require("private-next-pages/document-toolkit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document-toolkit"])
      });
    }
  